import { render, staticRenderFns } from "./t-label.vue?vue&type=template&id=30ad6144"
import script from "./t-label.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-label.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports